export default __webpack_public_path__ + "static/media/00.9967a994.jpg";